import { SVGProps, Ref, forwardRef } from 'react';

export const AdjustmentsOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.732 3.966C2.944 2.903 3.686 2 5.332 2s2.389.903 2.6 1.966H15.5v1.4H7.932c-.211 1.063-.954 1.966-2.6 1.966s-2.388-.903-2.6-1.966H.5v-1.4zm1.334.7c0-.459.117-.767.259-.937.104-.125.344-.33 1.007-.33s.903.205 1.007.33c.142.17.26.478.26.937 0 .458-.118.767-.26.936-.104.125-.344.33-1.007.33s-.903-.205-1.007-.33c-.142-.17-.259-.478-.259-.936"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.664 8.665c1.646 0 2.389.903 2.6 1.966H15.5v1.4h-2.236c-.212 1.063-.954 1.966-2.6 1.966s-2.388-.903-2.6-1.966H.5v-1.4h7.564c.211-1.063.954-1.966 2.6-1.966m-1.007 1.729c-.142.17-.259.478-.259.937 0 .458.117.767.259.936.104.125.344.33 1.007.33s.903-.205 1.007-.33c.142-.17.259-.478.259-.936s-.117-.767-.259-.937c-.104-.125-.344-.33-1.007-.33s-.903.205-1.007.33"
                fill="currentColor"
            />
        </g>
    </svg>
));
AdjustmentsOutlinedSize16Glyph.displayName = 'AdjustmentsOutlinedSize16Glyph';
